"use client"
import { Stack, VStack } from "@chakra-ui/react"
import { type FC } from "react"

import BlurFade from "@/components/Animations/BlurFade"
import MarkdownParser from "@/components/MarkdownParser"
import { type MarkdownBlock as MarkdownBlockType } from "@/types/database"
import getStickyContentBlockLeftProps from "@/utils/getStickyContentBlockLeftProps"

import ContentBlockTitle, {
  type ContentBlockTitleNumberProps,
} from "./ContentBlockTitle"

interface MarkdownBlockProps extends ContentBlockTitleNumberProps {
  block: MarkdownBlockType
}

const MarkdownBlock: FC<MarkdownBlockProps> = ({ block, titleNumber }) => {
  // console.log('block', block);
  const { content, darker_bg, description, title, two_columns_markdown } = block
  const trimmedTitle = title?.trim()
  const hasTitle =
    trimmedTitle !== undefined && trimmedTitle !== "" && trimmedTitle !== null
  const hasDescription =
    description !== undefined && description !== "" && description !== null

  return (
    <Stack
      alignItems="flex-start"
      bgColor={darker_bg ? "bg.subtle" : "transparent"}
      className="markdown-block internal-padding"
      direction={{
        base: "column",
        lg: two_columns_markdown ? "row" : "column",
      }}
      gap={{ base: 8, md: two_columns_markdown ? 6 : 8 }}
      justifyContent="flex-end"
    >
      {(hasTitle || hasDescription) && (
        <VStack
          alignItems="flex-start"
          className="markdown-block-left"
          flexGrow={1}
          maxWidth={{
            base: "100%",
            lg: two_columns_markdown ? "30%" : "100%",
          }}
          {...getStickyContentBlockLeftProps(two_columns_markdown)}
        >
          <BlurFade flexDirection="column" gap={0} inView>
            <ContentBlockTitle title={trimmedTitle} titleNumber={titleNumber} />
            {hasDescription && (
              <MarkdownParser
                color="fg.muted"
                fontSize="sm"
                markdown={description}
                pProps={{ fontFamily: "mono" }}
              />
            )}
          </BlurFade>
        </VStack>
      )}
      <VStack
        alignItems="flex-start"
        flexBasis={{ base: "auto", lg: "0" }}
        flexGrow={1}
        maxWidth={{
          base: "100%",
          lg: two_columns_markdown ? "70%" : "100%",
        }}
        pl={!hasTitle && two_columns_markdown ? { base: 0, lg: 12 } : 0}
      >
        <BlurFade flexDirection={"column"} inView>
          <MarkdownParser
            fontSize={{ base: "md", md: "md" }}
            headingProps={{ color: "fg" }}
            imgProps={{
              border: "1px solid",
              borderColor: "border.muted",
            }}
            markdown={content}
            pProps={{ color: "fg.muted" }}
          />
        </BlurFade>
      </VStack>
    </Stack>
  )
}

export default MarkdownBlock
